import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { CommonFunctions } from "../static/common-functions";
import { CommonValues } from "../static/CommonValues";

export class AssetAssignmentHistoryBus extends BaseBus {

    constructor(busObj: AssetAssignmentHistoryBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
    }
    assetHistoryId: any;
    assetId: any;
    insertUserId: any;
    inventoryLocationId: any;
    dispatchId: any;
    insertDt: Date;
    userFullName: string;
    dispatchNumber: string;
    inventoryLocationName: string;
    statusName: string;
}